import { gql } from "@apollo/client";


export const ATTENDENCE = gql(`
mutation($input:AttendanceInput){
    AttendenceLogin(input:$input){
    status
    message
    response{
        id
        punchIn
        punchOut
        elapsedTime
        status
    }
  }

}
 `)

export const GET_PROGRESS = gql`
  query GetProgress($id: String) {
    progress(id: $id) {
      status
      message
      response {
        today {
          hours
          targetHours
          progressPercent
        }
        week {
          hours
          targetHours
          progressPercent
        }
        month {
          hours
          targetHours
          progressPercent
        }
        monthlyOvertime {
          hours
          progressPercent
        }
        monthlyRemaining {
          hours
          progressPercent
        }
      }
         records{
      punchIn
      punchOut
      
    }
    }
  }
`;

export const GET_LAST_ATTENDENCE_RECORD = gql(`
    query($id:String){
    LastAttendence(id:$id){
      status
      message
      response{
        id
        empId
        punchIn
        punchOut
        status
        elapsedTime
      }
      
    }

}
    `)

export const UPDATE_PUNCHOUT = gql(`
    mutation($id:String,$input:AttendanceInput)
    {
    Attendenceupdate(id:$id,input:$input){
    status
    message
    }
}
    `)


export const GET_ALL_RECORDS = gql(`
      query($id:String,$date: String, $month: Int, $year: Int,$page:Int, $pageSize:Int) {
  AllAttendence(id:$id,date: $date, month: $month, year: $year, page: $page, pageSize: $pageSize) {
    status
    message
    totalRecords
    response {
      id
      punchIn
      punchOut
      empId
      status
       breaks {
          breakIn
          breakOut
        }
    }
  }
}
      
      `);

export const UPDATE_BREAK = gql`
      mutation updateBreak($attendanceId: ID!, $breakIn: String!, $breakOut: String!) {
        updateBreak(attendanceId: $attendanceId, breakIn: $breakIn, breakOut: $breakOut) {
       status
    message
    response {
        id
          breaks {
            breakIn
            breakOut
          }
        }
          
        }
      }
    `;
    export const GET_LOGIN_WORK_HISTORY = gql`
      query GetLoginWorkHistory($empId:String,$fromDate: String, $toDate: String) {
    LoginWorkHistoryResolver(empId:$empId,fromDate: $fromDate, toDate: $toDate) {
          _id
          firstname
          lastname
          department
          approvedLeaves {
            _id
            leaveType
            startDate
            endDate
            leaveStatus
          }
          holidays {
            holidayName
            holidayDate
          }
          attendanceRecords {
            punchOut
            status
            punchIn
          }
            loginWorkHistories {
      startTime
      endTime
      _id
    }
        }
      }
    `;